import { render, staticRenderFns } from "./InstructionPage.vue?vue&type=template&id=7dda55aa&"
import script from "./InstructionPage.vue?vue&type=script&lang=js&"
export * from "./InstructionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7dda55aa', component.options)
    } else {
      api.reload('7dda55aa', component.options)
    }
    module.hot.accept("./InstructionPage.vue?vue&type=template&id=7dda55aa&", function () {
      api.rerender('7dda55aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/InstructionPage.vue"
export default component.exports